import Helmet from 'react-helmet'

const Favicon = () => (
    <Helmet>
        <link rel="apple-touch-icon" sizes="180x180" href={require('./apple-touch-icon.png')} />
        <link rel="icon" type="image/png" sizes="32x32" href={require('./favicon-32x32.png')} />
        <link rel="icon" type="image/png" sizes="16x16" href={require('./favicon-16x16.png')} />
        {/* <link rel="manifest" href={require('./manifest.json')} /> */}
        <link rel="mask-icon" href={require('./safari-pinned-tab.svg')} color="#5bbad5" />
        <meta name="theme-color" content="#ffffff" />
    </Helmet>
)

export default Favicon
